import { getConfig } from "./component-library2.mjs";
const getCdnBaseUrl = () => {
  const { cloudFront } = getConfig() || {};
  if (!cloudFront || !cloudFront.imagesEnabled)
    return "";
  if (cloudFront.url)
    return cloudFront.url;
  return (cloudFront == null ? void 0 : cloudFront.host) ? `//${cloudFront.host}` : "";
};
const addCdnHost = (src) => {
  const cdnUrl = getCdnBaseUrl();
  if (!src || src.startsWith("//") || src.startsWith("http") || !cdnUrl)
    return src;
  return cdnUrl + (!src.startsWith("/") ? "/" : "") + src;
};
export {
  addCdnHost,
  getCdnBaseUrl
};
